import { Injectable } from '@angular/core';
import { RequestCacheModel } from '../models/request-cache-model.model';
import { HttpResponse, HttpRequest } from '@angular/common/http';
import { RequestCache } from './abstract/request-cache.service';
import { ResponseServiceModel } from '../models/response-service.model';

const MAX_CACHE_AGE = 30000; // maximum cache age (ms)

@Injectable()
export class RequestCacheWithMap implements RequestCache {

	cache = new Map<string, RequestCacheModel>();

	get(req: HttpRequest<any>): HttpResponse<ResponseServiceModel> | null {
		const entry = this.cache.get(req.urlWithParams);
		if (!entry) {
			return null;
		}
		const isExpired = (Date.now() - entry.lastRead) > MAX_CACHE_AGE;
		return isExpired ? null : entry.response;
	}

	put(req: HttpRequest<any>, response: HttpResponse<ResponseServiceModel>): void {
		const entry: RequestCacheModel = { url: req.urlWithParams, response: response, lastRead: Date.now() };
		this.cache.set(req.urlWithParams, entry);
		this.deleteExpiredCache();
	}

	private deleteExpiredCache() {
		this.cache.forEach(entry => {
			if ((Date.now() - entry.lastRead) > MAX_CACHE_AGE) {
				this.cache.delete(entry.url);
			}
		});
	}


}
